import React, { useEffect, useState } from "react";
import "./MatchList.css"; // Import CSS file
import * as MatchListService from "../../service/MatchListService";
import { stringToMomentDate } from "../../helpers/Utilities";
import UrlConstant from "../../helpers/UrlConstant";
import { useNavigate, useParams } from "react-router-dom";

const MatchList = () => {
  const navigate = useNavigate();
  const { matchId } = useParams();

  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getMatches();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getMatches = async () => {
    try {
      const data = await MatchListService.get(matchId);
      console.log("data", data);
      if (data && data?.length > 0) {
        setMatches(data);
      }
      setLoading(false);
    } catch (error) {
      console.log("getMatches error", error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loader-centered">
        <progress max="100" value="50"></progress>
      </div>
    );
  }

  return (
    <div className="match-list">
      {matches.map((match) => (
        <div
          onClick={() => {
            console.log(UrlConstant.thumbImageURL + match?.team1?.flag);
            navigate("/embed/player", { state: match });
          }}
          key={match.id}
          className="match-card"
        >
          {/* Header */}
          <div className="match-header">
            {stringToMomentDate(match.startDate, "").day},{" "}
            {stringToMomentDate(match.startDate, "").startDate}
          </div>

          {/* Date and Time */}
          <div className="match-info">
            {/* <p className="match-date">
              {stringToMomentDate(match.startDate, "").day},{" "}
              {stringToMomentDate(match.startDate, "").startDate}
            </p> */}
            <div className="time-container">
              <p className="vertical-text">
                <span className="label">LOCAL TIME:</span>{" "}
                <span className="bold">
                  {
                    stringToMomentDate(match.startDate, match.venueTimeZone)
                      .time
                  }
                </span>
              </p>
              <p className="vertical-text">
                <span className="label">YOUR TIME:</span>{" "}
                <span className="bold">
                  {stringToMomentDate(match.startDate, "").newDate}
                </span>
              </p>
            </div>
          </div>

          {/* Live Match Info */}
          <div className="match-content">
            {match.live && (
              <span className="live-badge">{match?.statusName}</span>
            )}
            <p className="match-subtitle">
              {match.title != null && match.title != ""
                ? match.title
                : match.poolName + " Match " + match.matchNumber}
            </p>
            <h2 className="match-title">
              <div className="team-logos">
                <img
                  src={UrlConstant.thumbImageURL + match?.team1?.flag}
                  alt={match?.team1?.abbrivation}
                  className="team-logo"
                />
                <img
                  src={UrlConstant.thumbImageURL + match?.team2?.flag}
                  alt={match?.team2?.abbrivation}
                  className="team-logo"
                />
              </div>
              {match?.team1?.abbrivation} v {match?.team2?.abbrivation}
            </h2>
            <p className="match-referee">
              <img
                src={UrlConstant.thumbImageURL + match?.refereePhoto}
                alt="Referee"
                className="referee-image"
              />
              {match?.refereeName}
            </p>
          </div>

          {/* Venue */}
          <div className="match-venue">{match?.venueName}</div>
        </div>
      ))}
    </div>
  );
};

export default MatchList;
